/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { JobApplicationStatus } from "./JobApplicationStatus";
import {
  JobApplicationStatusFromJSON,
  JobApplicationStatusFromJSONTyped,
  JobApplicationStatusToJSON,
  JobApplicationStatusToJSONTyped,
} from "./JobApplicationStatus";

/**
 *
 * @export
 * @interface UndoStatusesRequest
 */
export interface UndoStatusesRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof UndoStatusesRequest
   */
  applicationIds: Array<string>;
  /**
   *
   * @type {JobApplicationStatus}
   * @memberof UndoStatusesRequest
   */
  status: JobApplicationStatus;
  /**
   *
   * @type {Array<string>}
   * @memberof UndoStatusesRequest
   */
  noteIds: Array<string>;
}

/**
 * Check if a given object implements the UndoStatusesRequest interface.
 */
export function instanceOfUndoStatusesRequest(
  value: object,
): value is UndoStatusesRequest {
  if (!("applicationIds" in value) || value["applicationIds"] === undefined)
    return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("noteIds" in value) || value["noteIds"] === undefined) return false;
  return true;
}

export function UndoStatusesRequestFromJSON(json: any): UndoStatusesRequest {
  return UndoStatusesRequestFromJSONTyped(json, false);
}

export function UndoStatusesRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UndoStatusesRequest {
  if (json == null) {
    return json;
  }
  return {
    applicationIds: json["applicationIds"],
    status: JobApplicationStatusFromJSON(json["status"]),
    noteIds: json["noteIds"],
  };
}

export function UndoStatusesRequestToJSON(json: any): UndoStatusesRequest {
  return UndoStatusesRequestToJSONTyped(json, false);
}

export function UndoStatusesRequestToJSONTyped(
  value?: UndoStatusesRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    applicationIds: value["applicationIds"],
    status: JobApplicationStatusToJSON(value["status"]),
    noteIds: value["noteIds"],
  };
}
